import React, { Component } from 'react';

import AnimatedCard from './AnimatedCard';
import projectData from '../assets/data/project_data';


export default class Work extends Component {
  renderCards() {
    return projectData.map((project, index) => (
      <AnimatedCard
        key={index}
        name={project.name}
        description={project.description}
        img={project.img}
        alt={project.alt}
        demoLink={project.demoLink}
        viewLink={project.viewLink}
        detailSlug={project.detailSlug}
      />
    ))
  }
  render() {
    return (
      <section id='work'>
        <h2>My Work</h2>
        <hr className="special" />
        <div className="animated-grid">
        {this.renderCards()}
        </div>
      </section>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/work.js